const ProcessOfThesis = {
  tableConfig: {
    showCheckbox: true,
    minWidth: 1140
  },
  queryList: [
    {
      name: 'academyName',
      label: '院系名称',
      component: 'input'
    },
    {
      name: 'firstSubjectName',
      label: '一级学科',
      component: 'select',
      request: {
        method: 'post',
        addr: '/conf/confFirstSubject/all',
        data: {},
        format: {
          value: 'name',
          label: 'name'
        }
      }
    },
    {
      name: 'secondSubjectName',
      label: '二级学科',
      component: 'select',
      request: {
        method: 'post',
        addr: '/conf/confSecondSubject/all',
        data: {},
        format: {
          value: 'name',
          label: 'name'
        }
      }
    },
    {
      name: 'paperStatus',
      label: '评阅状态',
      component: 'select',
      componentAttr: {
        options: [{
          value: 0,
          label: '送审中'
        }, {
          value: 1,
          label: '评阅中'
        }, {
          value: 2,
          label: '完成评阅'
        }]
      }
    },
    {
      name: 'schoolNo',
      label: '学号',
      component: 'input'
    },
    {
      name: 'authorName',
      label: '姓名',
      component: 'input'
    },
    {
      name: 'submitTimeRange',
      label: '提交时间',
      component: 'dateRange'
    }
  ],
  urlMap: {
    'select': {
      url: '/paper/paperBaseInfo/queryPaperInfo',
      data: {
        state: 1
      }
    },
    'resultDownload': '/school/schoolAuditPlanConfig/downloadAuditSelected',
    'resultDownloadAll': '/school/schoolAuditPlanConfig/downloadAuditAll',
    'resultYmDownload': '/school/schoolAuditPlanConfig/downloadAuditYmSelected',
    'resultYmDownloadAll': '/school/schoolAuditPlanConfig/downloadAuditYmAll',
    'exportResult': '/paper/paperBaseInfo/exportReviewResult'
  },
  operList: [// 操作列表
    {
      name: 'chooseDownload',
      label: '选中评阅书下载',
      show: true,
      action: {
        type: 'request',
        data: '("{tableSelectionIds}").split(",")',
        addr: 'resultDownload',
        nextAction: 'download'
      }
    },
    {
      name: 'allDownload',
      label: '全部评阅书下载',
      show: true,
      action: {
        type: 'request',
        addr: 'resultDownloadAll',
        data: '{searchParam}',
        nextAction: 'download'
      }
    },
    {
      name: 'chooseDownloadYm',
      label: '选中评阅书下载（隐名）',
      show: true,
      action: {
        type: 'request',
        data: '("{tableSelectionIds}").split(",")',
        addr: 'resultYmDownload',
        nextAction: 'download'
      }
    },
    {
      name: 'allDownloadYm',
      label: '全部评阅书下载（隐名）',
      show: true,
      action: {
        type: 'request',
        addr: 'resultYmDownloadAll',
        data: '{searchParam}',
        nextAction: 'download'
      }
    },
    {
      name: 'downloadResult',
      label: '导出评阅结果',
      show: true,
      action: {
        type: 'request',
        addr: 'exportResult',
        data: {
          ids: '{tableSelectionIds}',
          queryReview: '{searchParam}'
        },
        confirm: {
          notSelected: true
        },
        nextAction: 'download'
      }
    },
    {
      name: 'download',
      label: '下载文件',
      show: false,
      action: {
        type: 'url',
        addr: '{data}'
      }
    }
  ],
  titles: [
    {
      name: 'id',
      key: true
    },
    {
      name: 'academyName',
      label: '所在学院'
    },
    {
      name: 'firstSubjectName',
      label: '一级学科'
    },
    {
      name: 'secondSubjectName',
      label: '二级学科'
    },
    {
      name: 'schoolNo',
      label: '学号',
      action: {
        title: '送审信息',
        type: 'dialog',
        addr: 'thesisManage/thesisEdit?{id}&readonly',
        width: 800
      }
    },
    {
      name: 'authorName',
      label: '姓名'
    },
    {
      name: 'titleCn',
      label: '论文题目'
    },
    {
      name: 'auditExpertNum',
      label: '送审专家数',
      width: 106
    },
    {
      name: 'reviewNum',
      label: '提交情况'
    },
    {
      name: 'rate',
      label: '接收情况'
    },
    {
      name: 'resultStr',
      label: '评阅结果'
    },
    {
      name: 'paperStatus',
      label: '评阅状态',
      map: {
        0: '送审中',
        1: '评阅中',
        2: '完成评阅'
      }
    },
    {
      name: 'operation',
      label: '评阅书下载',
      width: 110,
      actionList: [
        {
          filter: 'row.reviewNum > 0',
          label: '隐名',
          kind: 'primary',
          type: 'request',
          method: 'fetch',
          addr: '/school/schoolAuditPlanConfig/downloadAuditYmOne/{id}',
          nextAction: 'download'
        },
        {
          filter: 'row.reviewNum > 0',
          label: '非隐名',
          kind: 'primary',
          type: 'request',
          method: 'fetch',
          addr: '/school/schoolAuditPlanConfig/downloadAuditOne/{id}',
          nextAction: 'download'
        }
      ]
    }
  ]
}
export default ProcessOfThesis



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/thesisManage/processOfThesis.js